import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-paymentstatus',
  templateUrl: './paymentstatus.component.html',
  styleUrls: ['./paymentstatus.component.scss']
})
export class PaymentstatusComponent implements OnChanges {

  paymentstatusForm: FormGroup;
  paymentstatusFormArray: FormGroup;
  control = new FormControl();
  @Input() paymentstatuss: PaymentStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() paymentstatus = new EventEmitter<PaymentStatusDto[]>()
  @Output() deletePaymentStatusEvent = new EventEmitter<any>()

    selectedPaymentStatus: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createPaymentStatusForm();
    }

    createPaymentStatusForm() {
      this.paymentstatusForm = this.fb.group({
        PaymentStatusName: ['', Validators.required],
        id: null
        });
        this.paymentstatusFormArray = this.fb.group({ PaymentStatuss: this.fb.array([])
          });
        this.setPaymentStatus();
    }

  // method to display PaymentStatuss
  setPaymentStatus() {
    const control  = this.paymentstatusFormArray.controls.PaymentStatuss as FormArray;
    this.paymentstatuss.forEach( e => {
      control.push(
        this.fb.group({
          PaymentStatusName: e.PaymentStatusName,
          id: e.id
        })
      );
    });
  }


  // method to add PaymentStatus
  addPaymentStatus(value: PaymentStatusDto) {
    const control  = this.paymentstatusFormArray.controls.PaymentStatuss as FormArray;
    control.insert(0,
          this.fb.group({
            PaymentStatusName: value.PaymentStatusName,
            id: null
          })
       );
  }

  selectPaymentStatus(value) {}

  // method to delete PaymentStatus from arrary list
  deletePaymentStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.paymentstatusFormArray.controls.PaymentStatuss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.paymentstatuss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.paymentstatuss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: PaymentStatusDto) {
    if(this.paymentstatusForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.paymentstatusFormArray.get('PaymentStatuss')['controls'][this.selectedIndex].patchValue({PaymentStatusName: formValue.PaymentStatusName});
    } else {
      this.addPaymentStatus(formValue);
    }
    this.selectedIndex = null;
    this.paymentstatusForm.reset()
  }

  onEdit(index, value: PaymentStatusDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.paymentstatusForm.patchValue({PaymentStatusName: value.PaymentStatusName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.paymentstatusForm.reset();
  }

  onSubmit(formValue: PaymentStatusDto[]) {
  this.paymentstatus.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deletePaymentStatusEvent.emit(this.filteredDelete);
  }
  }
}

